export enum EncryptionStatus {
    Success = 'success',
    Error = 'error',
}

export interface EncryptionSuccessResponse {
    state: EncryptionStatus.Success;
    message: string;
    id: string;
    dek: string;
    createdAt: string;
    modifiedAt: string;
}
export interface EncryptionErrorResponse {
    state: EncryptionStatus.Error;
    error: string;
}
export type EncryptionResponse = EncryptionSuccessResponse | EncryptionErrorResponse;
